import { Pipe, PipeTransform } from '@angular/core';
import * as tinycolor from 'tinycolor2';

@Pipe({
  name: 'colorLight',
})
export class ColorLightPipe implements PipeTransform {
  transform(value: any, ...args: any[]): string {
    const color = tinycolor(value);
    return color.getLuminance() >= 0.5 ? '#000000' : '#FFFFFF';
  }
}
